import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';
import { Map, ExternalLink } from 'lucide-react';

const SitemapPage = () => {
  const sections = [
    {
      title: 'Main Platform',
      links: [
        { name: 'Home Page', path: '/' },
        { name: 'Student Dashboard', path: '/student/dashboard' },
        { name: 'My Courses', path: '/student/mycourses' },
        { name: 'Certificates', path: '/student/certificates' },
        { name: 'Profile & Settings', path: '/student/profile' },
        { name: 'Support', path: '/student/support' }
      ]
    },
    {
      title: 'E-Learn Business & Careers',
      links: [
        { name: 'Teach on E-Learn', path: '/teach-on-elearn' },
        { name: 'Get the App', path: '/get-the-app' },
        { name: 'About Us', path: '/about-us' },
        { name: 'Contact Us', path: '/contact-us' },
        { name: 'Blog & Articles', path: '/blog' },
        { name: 'Help & Support', path: '/help-and-support' },
        { name: 'Affiliate Program', path: '/affiliate' },
        { name: 'Investors', path: '/investors' }
      ]
    },
    {
      title: 'Legal & Accessibility',
      links: [
        { name: 'Terms of Service', path: '/terms-of-service' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Sitemap', path: '/sitemap' },
        { name: 'Accessibility Statement', path: '/accessibility' }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        
        {/* Compact Hero Banner */}
        <div className="bg-gradient-to-r from-emerald-800 via-teal-900 to-emerald-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 text-white text-center space-y-1 shadow-xs">
          <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
            Navigation Overview
          </span>
          <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">E-Learning Hub Sitemap</h1>
          <p className="text-emerald-100/90 text-[11px] sm:text-xs max-w-xl mx-auto">
            Full Directory of All Available Routes and Pages
          </p>
        </div>

        <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-100 shadow-2xs">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            {sections.map((section, idx) => (
              <div key={idx} className="space-y-2.5">
                <h2 className="text-xs sm:text-sm font-bold text-gray-900 border-b border-emerald-100 pb-1.5 flex items-center gap-1.5">
                  <Map size={15} className="text-emerald-600 shrink-0" />
                  {section.title}
                </h2>
                <ul className="space-y-1.5">
                  {section.links.map((link, lIdx) => (
                    <li key={lIdx}>
                      <Link
                        to={link.path}
                        className="text-[11px] sm:text-xs text-gray-600 hover:text-emerald-600 hover:font-bold transition-all flex items-center gap-1.5"
                      >
                        <ExternalLink size={12} className="text-gray-400 shrink-0" />
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SitemapPage;
